require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./impact-of-crime-maps-on-public-perceptions.json") })
        }
      }, "path---impact-of-crime-maps-on-public-perceptions");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---impact-of-crime-maps-on-public-perceptions!./.cache/json/impact-of-crime-maps-on-public-perceptions.json
// module id = 906
// module chunks = 231608221292675